export default __webpack_public_path__ + "static/media/logo-netflix.05a0a5b4.svg";